import './SchedulerConfigTimes.scss'

import { useEffect, useState } from "react";

import AppLoading from "../../commons/AppLoading";
import CompanyAPI from "../company/CompanyAPI";
import HallAppToast from "../../commons/HallAppToast";
import PullToRefresh from "react-simple-pull-to-refresh";
import SchedulerConfigAPI from "./SchedulerConfigAPI";
import Weeks from "./components/Weeks";

function SchedulerConfigTimes({employeeId, fetchAll}) {
  const schedulerAPI = new SchedulerConfigAPI();
  const companyAPI = new CompanyAPI();

  const [configWeeks, setConfigWeeks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getConfigWeek = async () => {
    try {
      setIsLoading(true);
      const response = await schedulerAPI.getConfigEmployee(companyAPI.getCompanyManagment().id, employeeId);
      setConfigWeeks(response.data || []);
    } catch (_) {
      HallAppToast.genericError();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getConfigWeek();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="ha-schedulerTimes">
      <PullToRefresh onRefresh={getConfigWeek}>
        <div className="ha-schedulerTimes__header">
          <div>
            <div className="ha-schedulerTimes__title">Horários de atendimento</div>
            <div className="ha-schedulerTimes__subtitle">
              Ative os dias e toque no horário para editar. Puxe para baixo para atualizar.
            </div>
          </div>

          <button type="button" className="ha-schedulerTimes__refreshBtn" onClick={getConfigWeek}>
            <i className="bi bi-arrow-clockwise" />
            Atualizar
          </button>
        </div>

        {isLoading ? (
          <div className="ha-schedulerTimes__loading">
            <AppLoading />
          </div>
        ) : (
          <div className="ha-schedulerTimes__list">
            {configWeeks.map((data) => (
              <Weeks fetchAll={fetchAll} key={data.dayOfWeek} weekConfig={data} employeeId={employeeId} />
            ))}
          </div>
        )}

        <div className="ha-schedulerTimes__footerSpace" />
      </PullToRefresh>
    </div>
  );
}

export default SchedulerConfigTimes;
